import * as React from 'react'

import * as errors from '../constants/errors'

// @flow
type Props = {
    error: {
        name: string,
        type: string,
    },
    theme: {
        errorInline: string,
        errorInlineCtr: string,
    },
}

// Displays inline errors, mostly used for form validation
function ErrorInline(props: Props) {
    return (<div className={props.theme.errorInlineCtr}>
        {props.error.type === errors.EMPTY_FIELD_REQUIRED &&
            <div className={props.theme.errorInline}>
                Please provide a value for { props.error.name }.
            </div>
        }
    </div>)
}

ErrorInline.defaultProps = {}

export default ErrorInline
